<script>
    import { Statistic,initStatistic, Text, Icon } from "svantic";
    initStatistic()
    import {
        createBetWs
    } from "../../../../scripts/stake-api";

    let bet = { }



    export const placeBet =  async (...args) => {
        try {

             let r = await createBetWs(...args)
            if( r.data )
                bet =  r.data 
           
            return r
        } catch (e) {
            //any connection related error
            console.error("catch error fnc placeBet - e: ", e);
            return {error: e, data: null}
        }
        finally{

        }
    };
</script>

<Statistic size="huge" inverted>
    <Statistic.Value text={true}>
        {#key bet}
            { (bet.result) ? bet.result.result.toFixed(2) : "" } <Icon size="small" name="times"></Icon>
        {/key}
          
    </Statistic.Value>
    <Statistic.Label><Text class="medium">Roll</Text></Statistic.Label>
</Statistic>

<style>
</style>
